// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"77ea2a11","82":"b67b61bc","247":"177417c8","312":"8638f6b1","422":"a3f0a801","472":"28b8e99a","551":"396790a8","627":"da0e2477","828":"9a7920e4","834":"5812f9dd","867":"f264eb66","923":"e590622f","938":"980f7743","950":"dbcd1896"}[chunkId] + ".chunk.js";
};